var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "sep"
  }), _vm._m(1), _c('div', {
    staticClass: "btnwrap fixedbottom"
  }, [_vm.redirectUrl ? _c('a', {
    attrs: {
      "href": _vm.redirectUrl
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/btn_next.png"),
      "alt": _vm.redirectText
    }
  })]) : _c('a', {
    attrs: {
      "href": "https://line.me/R/ti/p/@huggiestw"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/return_btn.png"),
      "alt": "結束"
    }
  })])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h1', [_c('span', {
    staticClass: "title"
  }, [_vm._v("您已成功加入")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wrap-content"
  }, [_c('h6', {
    staticStyle: {
      "text-align": "center",
      "color": "#333",
      "margin-bottom": "20px"
    }
  }, [_vm._v(" 您已成功加入 Huggies 好奇 LINE 官方帳號。 ")])]);
}]

export { render, staticRenderFns }